export default "__VITE_ASSET__970ff0e3__$_?nuxt_component=async&nuxt_component_name=SvgoFreedash__"